module.exports = __webpack_public_path__ + "img/suffering_bastard.826c7652.jpg";